module.exports = __webpack_public_path__ + "static/media/BotBIcon_MiniSet.36391d54.png";